import { useContext } from "react";
import { WeekIndexContext } from "./context";

export const useWeekIndex = () => {
	return useContext(WeekIndexContext);
};
